<!-- 教育培训 -->
<template>
  <div class="study">
    <img src="../assets/images/no.jpg" alt srcset />
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
}
</script>

<style scoped lang="less">
.study {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #fff;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
